export default "__VITE_ASSET__ChKx5Wz8__"